import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Grid,
  Item,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import AddEquipment from "./AddDriver";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DescriptionIcon from "@mui/icons-material/Description"; // For CSV
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import DocumentItem from "../../../../../Components/Masters/DocumentItem";
import { useUser } from "../../../../../context/AuthContext";
import { europeanCountries } from "../../../../../utils/countriesArray";

function ViewDriver(props) {
  const { user } = useUser();

  const [addFacility, setAddEquipment] = useState(false);

  const handleDownload = (url) => {
    const downloadUrl = url.replace("/upload/", "/upload/fl_attachment/");
    const link = document.createElement("a");
    link.href = downloadUrl;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const Edit = () => {
    props.handleEdit();
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "28rem",

        // width: 422,
        // maxWidth: "100%",
        height: "100vh",
        // justifyContent: "space-between",
        backgroundColor: "transparent",
        overflowX: "hidden", // Prevent horizontal overflow
      }}
    >
      <AddEquipment
        addFacility={addFacility}
        setAddFacility={setAddEquipment}
        selectedFacility={props.selectedFacility}
        setsnackOpen={props.setsnackOpen}
        fetchFacilities={props.fetchFacilities}
      />

      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setViewFacility(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          p: 3,
          width: "410px",
          backgroundColor: "#fff",
          height: "100%",
          overflowY: "auto", // Enable vertical scrolling only
          overflowX: "hidden", // Ensure no horizontal scrolling
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Driver Details
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography sx={{ fontWeight: "bold" }}>Date</Typography>
            <p>
              {new Date(props.selectedFacility?.createdAt).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }
              )}
            </p>
            {/* <Item>xs=8</Item> */}
          </Grid>
          <Grid item xs={6}>
            <Tooltip title="Logistics Vendor name" arrow>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  // mt: 1,
                  cursor: "pointer", // Show pointer cursor on hover
                }}
              >
                Logistics Vendor
              </Typography>
            </Tooltip>
            <p style={{}}>
              {props.selectedFacility?.logisticsVendor?.logisticVendorLegalName}
            </p>{" "}
          </Grid>

          {/* <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Facility
            </Typography>
            <p>{props.selectedFacility?.facility?.facilityName ?? ""}</p>
          </Grid> */}

          <Grid item xs={6}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                mt: -1,
              }}
            >
              Country
            </Typography>
            <Tooltip title={props.selectedFacility?.country ?? ""} arrow>
              <p
                style={{
                  overflow: "hidden", // Hides overflow text
                  whiteSpace: "nowrap", // Prevents text from wrapping to the next line
                  textOverflow: "ellipsis", // Displays ellipsis for overflowing text
                  maxWidth: "160px", // Set a maximum width for truncation
                  cursor: "pointer", // Makes it clear the text is interactive
                }}
              >
                {props.selectedFacility?.country ?? ""}
              </p>
            </Tooltip>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Driver Name
            </Typography>
            <p>{props.selectedFacility?.driverName}</p>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              {europeanCountries?.find(
                (el) => el?.countryName === props.selectedFacility?.country
              )?.key3 || "Govt. ID Number"}{" "}
            </Typography>
            <p style={{ marginLeft: "6px" }}>
              {props.selectedFacility?.aadharNumber}
            </p>{" "}
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Driver License No
            </Typography>
            <p>{props.selectedFacility?.licenseNumber}</p>
            {/* <Item>xs=4</Item> */}
          </Grid>
          <Grid item xs={6}>
            <Tooltip title="License Expiry Date" arrow>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mt: -1,
                  // mt: 1,
                  cursor: "pointer", // Show pointer cursor on hover
                }}
              >
                License Expiry
              </Typography>
            </Tooltip>
            <p>
              {new Date(
                props.selectedFacility?.licenseExpiryDate
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </p>
          </Grid>

          {/* test */}

          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Mobile No.
            </Typography>
            <p>
              {props.selectedFacility?.countryCode ?? ""}{" "}
              {props.selectedFacility?.phone ?? ""}
            </p>
            {/* <Item>xs=4</Item> */}
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                mt: -1,
              }}
            >
              Email
            </Typography>
            <Tooltip title={props.selectedFacility?.email ?? ""} arrow>
              <p
                style={{
                  overflow: "hidden", // Hides overflow text
                  whiteSpace: "nowrap", // Prevents text from wrapping to the next line
                  textOverflow: "ellipsis", // Displays ellipsis for overflowing text
                  maxWidth: "160px", // Set a maximum width for truncation
                  cursor: "pointer", // Makes it clear the text is interactive
                }}
              >
                {props.selectedFacility?.email ?? ""}
              </p>
            </Tooltip>
          </Grid>
        </Grid>

        {/* Display selected facility information */}
        <Grid container spacing={1}>
          {/* Align the following fields on the same row */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Govt. ID
            </Typography>
          </Grid>
        </Grid>
        <Box
          display="flex"
          flexDirection="column"
          gap={1}
          sx={{ width: "100%" }}
        >
          {/* Render Images First */}
          {props.selectedFacility &&
            props.selectedFacility?.aadharDoc.length > 0 && (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedFacility?.aadharDoc
                  .filter((url) =>
                    ["png", "jpg", "jpeg"].includes(
                      url.split(".").pop().toLowerCase()
                    )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`image-${index}`} url={url} />
                  ))}
              </Box>
            )}

          {/* Render Other Documents */}
          {props.selectedFacility &&
            props.selectedFacility?.aadharDoc.length > 0 && (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedFacility?.aadharDoc
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            )}

          {props.selectedFacility?.aadharDoc.length === 0 ? <p>-</p> : null}
        </Box>

        {/* License Document */}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
        >
          License
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          gap={1}
          sx={{ width: "100%" }}
        >
          {/* Render Images First */}
          {props.selectedFacility &&
            props.selectedFacility?.licenseDoc.length > 0 && (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedFacility?.licenseDoc
                  .filter((url) =>
                    ["png", "jpg", "jpeg"].includes(
                      url.split(".").pop().toLowerCase()
                    )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`image-${index}`} url={url} />
                  ))}
              </Box>
            )}

          {/* Render Other Documents */}
          {props.selectedFacility &&
            props.selectedFacility?.licenseDoc.length > 0 && (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedFacility?.licenseDoc
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            )}

          {props.selectedFacility?.licenseDoc.length === 0 ? <p>-</p> : null}
        </Box>

        {!user?.companyAdmin && (
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "10%",
              }}
              onClick={Edit}
            >
              Edit
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      anchor="right"
      open={props.viewFacility}
      onClose={() => props.setViewFacility(false)}
    >
      {list()}
    </Drawer>
  );
}

export default ViewDriver;
